import React, { Component, ErrorInfo } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../firebase/FirebaseCredential";
import {
  Button,
  Text,
  Box,
  Container,
  Image,
  Group,
  Input,
} from "@mantine/core";
import crashImage from "../../assets/crashimg.png";

interface Props {
  children: React.ReactNode;
  fallbackMessage?: string; // Optional fallback message
}

interface State {
  hasError: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
}

class ErrorBoundary extends Component<Props, State> {
  static defaultProps = {
    fallbackMessage: "An unexpected error occurred. Please try again later.",
  };

  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught an error: ", error, errorInfo);

    // Log the error to Firestore
    const errorsCollectionRef = collection(db, "errors");
    addDoc(errorsCollectionRef, {
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
      timestamp: new Date(),
    }).catch((err) => console.error("Error logging to Firestore:", err));
  }

  handleRetry = () => {
    // Reset the error state to retry rendering
    this.setState({ hasError: false, error: undefined, errorInfo: undefined });
  };

  render() {
    const { hasError, error } = this.state;
    const { children, fallbackMessage } = this.props;

    if (hasError) {
      return (
        <Container
          size="sm"
          sx={{
            textAlign: "center",
            marginTop: "4rem",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box sx={{ padding: "2rem", borderRadius: "8px" }}>
            <Text weight={700} size="xl" sx={{ marginBottom: "1rem" }}>
              SORRY
            </Text>
            <Text size="md" sx={{ marginBottom: "1rem" }}>
              {fallbackMessage}
            </Text>

            {/* Image */}
            <Image
              src={crashImage}
              alt="An illustration of an error occurring"
              sx={{
                margin: "auto",
                maxWidth: "300px",
                marginBottom: "1rem",
              }}
            />

            {/* Retry Button */}
            <Group position="center" sx={{ marginTop: "2rem" }}>
              <Button variant="filled" color="blue" onClick={this.handleRetry}>
                Retry
              </Button>
              <Button
                variant="outline"
                color="gray"
                onClick={() => (window.location.href = "/home")}
              >
                Go to home
              </Button>
            </Group>
          </Box>
        </Container>
      );
    }

    return children;
  }
}

export default ErrorBoundary;


// import React, { Component, ErrorInfo } from "react";
// import { collection, addDoc } from "firebase/firestore";
// import { db } from "../../firebase/FirebaseCredential";

// interface Props {
//   children: React.ReactNode;
//   fallbackMessage?: string; // Optional fallback message
//   showRetryButton?: boolean; // Optionally show a retry button
// }

// interface State {
//   hasError: boolean;
//   error?: Error;
//   errorInfo?: ErrorInfo;
// }

// class ErrorBoundary extends Component<Props, State> {
//   static defaultProps: { fallbackMessage: string; showRetryButton: boolean; };
//   constructor(props: Props) {
//     super(props);
//     this.state = { hasError: false };
//   }

//   static getDerivedStateFromError(error: Error) {
//     // Update state so the next render shows the fallback UI
//     return { hasError: true, error };
//   }

//   componentDidCatch(error: Error, errorInfo: ErrorInfo) {
//     console.error("ErrorBoundary caught an error: ", error, errorInfo);

//     // Save the error information to Firestore
//     const errorsCollectionRef = collection(db, "errors");
//     addDoc(errorsCollectionRef, {
//       message: error.message,
//       stackTrace: error.stack,
//       errorInfo: errorInfo.componentStack,
//       timestamp: new Date(),
//       environment: {
//         userAgent: navigator.userAgent,
//         platform: navigator.platform,
//         language: navigator.language,
//         appVersion: navigator.appVersion,
//       },
//     });

//     this.setState({ error, errorInfo });
//   }

//   handleRetry = () => {
//     // Reset the error state and try rendering again
//     this.setState({ hasError: false, error: undefined, errorInfo: undefined });
//   };

//   render() {
//     const { hasError, error, errorInfo } = this.state;
//     const { children, fallbackMessage, showRetryButton } = this.props;

//     if (hasError) {
//       return (
//         <div style={{ padding: "2rem", textAlign: "center" }}>
//           <h1>Sorry</h1>
//           {fallbackMessage && <p>{fallbackMessage}</p>}
//           {error && (
//             <details style={{ whiteSpace: "pre-wrap", textAlign: "left" }}>
//               <summary>Error Details</summary>
//               <p>{error.message}</p>
//               <pre>{error.stack}</pre>
//               {errorInfo && <pre>{errorInfo.componentStack}</pre>}
//             </details>
//           )}
//           {showRetryButton && (
//             <button onClick={this.handleRetry} style={{ marginTop: "1rem" }}>
//               Retry
//             </button>
//           )}
//         </div>
//       );
//     }

//     return children;
//   }
// }

// ErrorBoundary.defaultProps = {
//   fallbackMessage: "An unexpected error occurred. Please try again later.",
//   showRetryButton: true,
// };

// export default ErrorBoundary;

// // import React from "react";

// import { collection, addDoc } from 'firebase/firestore';
// import React, { Component, ErrorInfo } from 'react';
// import { db } from '../../firebase/FirebaseCredential';

// interface Props {
//   children: React.ReactNode;
// }

// interface State {
//   hasError: boolean;
// }

// class ErrorBoundary extends Component<Props, State> {
//   constructor(props: Props) {
//     super(props);
//     this.state = { hasError: false };
//   }

//   // componentDidCatch(error: Error, errorInfo: ErrorInfo) {
//   //   console.error('ErrorBoundary caught an error: ', error, errorInfo);
//   //   this.setState({ hasError: true });
//   // }
//   componentDidCatch(error: Error, errorInfo: ErrorInfo) {
//     console.error('ErrorBoundary caught an error: ', error, errorInfo);

//     // Save the error information to Firestore
//     const errorsCollectionRef = collection(db, 'errors');
//     addDoc(errorsCollectionRef, {
//       message: error.message,
//       stackTrace: error.stack,
//       errorInfo: errorInfo.componentStack,
//       timestamp: new Date(),
//     });

//     this.setState({ hasError: true });
//   }
//   render() {
//     if (this.state.hasError) {
//       return <h1>Something went wrong.</h1>;
//     }

//     return this.props.children;
//   }
// }

// export default ErrorBoundary;
